import { Link } from '~/components/ui/Link';
import { HELP_CENTER_URL } from '~/lib/urls';

export const items = [
  {
    question: 'What are tokens?',
    answer: (
      <>
        AI tokens are a complex topic related to all AI apps, not just Bolt. You can learn more about tokens{' '}
        <Link href="https://docs.anthropic.com/en/docs/resources/glossary#tokens" target="_blank">
          here
        </Link>
        . For Bolt specifically it is important to know that most token usage is related to syncing your project’s file
        system to the AI: the larger the project, the more tokens used per message. Our top priority is to increase the
        efficiency of token usage in Bolt. We continue to make improvements so that Bolt uses fewer tokens.
      </>
    ),
  },
  {
    question: 'How do Teams plans work?',
    answer: (
      <>
        Teams provide a shared workspace for users to collaborate on Bolt projects. The subscription cost for Teams is
        per team member. Each paid team member receives a monthly token allotment based on the subscription tier. Tokens
        are not shared among team members. You can read more about Teams plans{' '}
        <Link href={`${HELP_CENTER_URL}/account-and-subscription/team-plans#teams-plans`} target="_blank">
          here
        </Link>
        .
      </>
    ),
  },
  {
    question: 'Do tokens rollover from month to month?',
    answer: (
      <>
        Starting July 1, 2025, tokens from a paid subscription will roll over for one additional month, making them
        valid for up to two months in total. Please note that an active paid subscription is required to access any
        rolled over tokens. For more details, please refer to{' '}
        <Link href={`${HELP_CENTER_URL}/account-and-subscription/tokens#token-rollover`} target="_blank">
          this article
        </Link>
        .
      </>
    ),
  },
  {
    question: 'Can I change my plan later? ',
    answer: (
      <>
        Yes, you can change your plan by clicking <span className="font-semibold">Manage current plan</span>. This will
        take you to our Stripe billing portal where you can select{' '}
        <span className="font-semibold">Update subscription</span> to change your plan type.
      </>
    ),
  },
  {
    question: 'Can I cancel my subscription?',
    answer: (
      <>
        Yes, you can cancel at any time. Click <span className="font-semibold">Manage current plan</span> to be taken
        into the cancellation process.
      </>
    ),
  },
  {
    question: 'What are the token limits associated with a free plan?',
    answer: 'Free plans have a 150,000 token daily limit and 1 million token monthly limit.',
  },
];
